import { AsyncPipe, NgClass } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Eula } from '@polaris-customerweb/sharedcomponents.shared';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { MarkedDirective } from 'src/app/directives/marked.directive';
import { AppState } from 'src/app/models/app-state';
import { WINDOW } from 'src/app/state/app-config/factories/window.factory';
import { UserAuthService } from 'src/app/state/user-auth/user-auth.service';
import { selectEula } from '../eula.reducer';

@Component({
    imports: [NgClass, MarkedDirective, AsyncPipe],
    selector: 'rdx-eula',
    styleUrls: ['./eula.component.scss'],
    templateUrl: './eula.component.html',
})
export class EulaComponent implements OnInit, OnDestroy {
    eulaEntry: Observable<Eula>;
    isAuthenticated$: Observable<boolean>;
    eulaCompleteDescription: string;

    private isDestroyed = false;

    constructor(
        store: Store<AppState>,
        private userAuthService: UserAuthService,
        @Inject(WINDOW) private window: Window
    ) {
        this.eulaEntry = store.select(selectEula);
        this.eulaEntry
            .pipe(takeWhile(() => !this.isDestroyed))
            .subscribe((eula) => {
                this.eulaCompleteDescription = eula.description;
            });
    }

    ngOnInit() {
        this.window.addEventListener('popstate', () => {
            this.window.history.forward();
            this.window.location.reload();
        });
        this.isAuthenticated$ = this.userAuthService.isAuthenticated$;
    }

    ngOnDestroy(): void {
        this.isDestroyed = true;
    }
}
